import { useMutation, useQueryClient } from '@tanstack/react-query';
import type { UpdateSiteRequest } from '@billda/api';
import { updateSite } from '../api/sitesApi';
import { sitesKeys } from './useSites';

/**
 * Mutation hook for updating a site's editable fields.
 *
 * Errors are handled by the global QueryClient onError (shows snackbar).
 * Callers can override with mutate(data, { onSuccess, onError }).
 */
export const useUpdateSite = (siteId: number) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (data: UpdateSiteRequest) => updateSite(siteId, data),

    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: sitesKeys.lists(),
      });
      queryClient.invalidateQueries({
        queryKey: sitesKeys.detail(siteId),
      });
    },
  });
};
